import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Star } from 'lucide-react';
export function CTASection() {
  const scrollToBonuses = () => {
    const bonosSection = document.getElementById('bonos');
    if (bonosSection) {
      bonosSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="py-32 px-4 bg-[#0A0D14] text-[#F7F5F2] relative overflow-hidden text-center" data-id="element-14">
      {/* Mystical Background */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-15" />
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[#0A0D14] via-[#0C0F17] to-[#111522]" data-id="element-16" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-17">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex justify-center mb-8" data-id="element-18">
          <motion.div animate={{
          opacity: [0.4, 0.7, 0.4]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-19">
            <Star className="text-[#CFA86A] w-8 h-8" data-id="element-20" />
          </motion.div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-4xl md:text-6xl font-bold mb-8 font-serif text-[#F7F5F2]" data-id="element-21">
          Deja de sabotear tu propia vida
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-xl md:text-2xl mb-12 text-[#F7F5F2]/80 max-w-2xl mx-auto font-light" data-id="element-22">
          Si sigues posponiendo decisiones por ruido mental, estás perdiendo
          oportunidades. Usa un método probado.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-23">
          <button onClick={scrollToBonuses} className="px-12 py-6 rounded-lg bg-[#CFA86A] text-[#0C0A09] text-xl font-bold tracking-wide transition-all duration-300 hover:brightness-110 flex items-center gap-2 mx-auto shadow-2xl" style={{
          boxShadow: '0 0 40px rgba(207, 168, 106, 0.4)'
        }} data-id="element-24">
            Descarga Ahora y Accede a Tu Claridad
            <span data-id="element-25">→</span>
          </button>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.45,
        ease: [0.22, 1, 0.36, 1]
      }} className="mt-12 text-sm text-[#F7F5F2]/40 tracking-widest uppercase" data-id="element-26">
          Garantía de satisfacción de 21 días
        </motion.p>
      </div>
    </section>;
}